export function createAlgoliaFacetFiltersFromQueryMetaData(algoliaQueryMetaData) {
  const {
    filter
  } = algoliaQueryMetaData;
  return Object.entries(filter).filter(_ref => {
    let [key] = _ref;
    return key !== '__typename';
  }).flatMap(_ref2 => {
    let [key, value] = _ref2;
    return Array.isArray(value) ? value.map(v => "".concat(key, ":").concat(v)) : ["".concat(key, ":").concat(value)];
  });
}